var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 44.58,
    viewBox: "0 0 147 44.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-5 {\n        opacity: .38;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #f6aa1b;\n      }\n\n      .cls-4 {\n        fill: #fde440;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 16.64,
    y1: 22.29,
    x2: 20.68,
    y2: 22.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 23.9,
    y1: 22.29,
    x2: 28.47,
    y2: 22.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221f1f",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.08,22.29c0,9.82-7.96,17.78-17.79,17.78S4.51,32.11,4.51,22.29,12.47,4.51,22.29,4.51s17.79,7.95,17.79,17.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.29,0C9.98,0,0,9.98,0,22.29s9.98,22.29,22.29,22.29,22.29-9.98,22.29-22.29S34.6,0,22.29,0ZM22.29,41.41c-10.56,0-19.12-8.56-19.12-19.12S11.73,3.17,22.29,3.17s19.12,8.56,19.12,19.12-8.56,19.12-19.12,19.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.08,22.29c0,9.82-7.96,17.78-17.79,17.78S4.51,32.11,4.51,22.29,12.47,4.51,22.29,4.51s17.79,7.95,17.79,17.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.08,22.29c0,9.82-7.96,17.78-17.79,17.78S4.51,32.11,4.51,22.29,12.47,4.51,22.29,4.51s17.79,7.95,17.79,17.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.51,14.71c2.26,0,3.75.79,5.21,1.98l-1.74,2.52c-.99-.91-2.12-1.37-3.47-1.37-2.58,0-4.2,1.84-4.2,4.16s1.61,4.16,4.2,4.16c1.35,0,2.48-.46,3.47-1.37l1.74,2.52c-1.45,1.19-2.95,1.98-5.21,1.98-4.78,0-7.79-3.35-7.79-7.29s3.01-7.29,7.79-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.98,29.06v-14.59h3.47v14.59h-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.68,18.61v10.45h-3.47v-1.43c-.67,1.03-1.7,1.65-3.17,1.65-3.01,0-5.05-2.38-5.05-5.47s1.96-5.43,5.03-5.43c1.37,0,2.54.65,3.19,1.61v-1.39h3.47ZM77.87,26.56c1.37,0,2.42-.99,2.42-2.64s-.99-2.79-2.46-2.79-2.34,1.21-2.34,2.68.91,2.74,2.38,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.58,25.33c.26,1.11,1.17,1.43,2,1.43.63,0,1.21-.2,1.21-.69,0-.28-.18-.44-.75-.69l-1.74-.73c-1.65-.61-2.79-1.63-2.79-3.11,0-1.92,1.92-3.17,4.26-3.17,1.45,0,3.07.48,3.98,2.38l-2.6.99c-.26-.77-.99-.93-1.41-.93-.56,0-.99.28-.99.71,0,.36.34.56.87.75l1.39.56c2.42.89,3.03,2.12,3.03,3.23,0,2.1-2.12,3.21-4.5,3.21-1.94,0-3.92-.73-4.48-2.95l2.52-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.32,25.33c.26,1.11,1.17,1.43,2,1.43.63,0,1.21-.2,1.21-.69,0-.28-.18-.44-.75-.69l-1.74-.73c-1.65-.61-2.79-1.63-2.79-3.11,0-1.92,1.92-3.17,4.26-3.17,1.45,0,3.07.48,3.98,2.38l-2.6.99c-.26-.77-.99-.93-1.41-.93-.56,0-.99.28-.99.71,0,.36.34.56.87.75l1.39.56c2.42.89,3.03,2.12,3.03,3.23,0,2.1-2.12,3.21-4.5,3.21-1.94,0-3.92-.73-4.48-2.95l2.52-1.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.57,21.69c1.7.3,2.83,1.98,2.83,3.31,0,2.44-2.1,4.06-5.19,4.06h-6.22v-14.15l5.63.02c2.95.02,5.17,1.49,5.17,3.93,0,1.09-.73,2.26-2.22,2.83ZM108.08,20.72c1.69,0,2.12-.75,2.12-1.55,0-.93-.77-1.39-1.76-1.39h-1.88v2.95h1.51ZM106.57,23.11v3.07h2.56c1.05,0,1.68-.57,1.68-1.37s-.54-1.69-2.6-1.69h-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.12,18.61v10.45h-3.47v-1.43c-.67,1.03-1.7,1.65-3.17,1.65-3.01,0-5.05-2.38-5.05-5.47s1.96-5.43,5.03-5.43c1.37,0,2.54.65,3.19,1.61v-1.39h3.47ZM120.31,26.56c1.37,0,2.42-.99,2.42-2.64s-.99-2.79-2.46-2.79-2.34,1.21-2.34,2.68.91,2.74,2.38,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.94,18.69h3.47v1.37c.75-1.11,1.78-1.59,3.11-1.59,3.05,0,3.69,2.54,3.69,4.82v5.85h-3.47v-5.65c0-1.01-.38-2.24-1.65-2.24s-1.67,1.05-1.67,2.24v5.65h-3.47v-10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.05,18.61h3.73v.46c-1.13,1.43-2.22,2.91-3.35,4.34l1.21,2.02c.46.71.85.87,1.37.87.22,0,.75-.12,1.07-.34.4.75.79,1.51,1.17,2.28-.99.83-2.02,1.05-2.93,1.05-1.7,0-2.72-.63-3.87-2.7l-1.21-2.2v4.68h-3.47v-14.59h3.47v8.36c.95-1.39,1.88-2.81,2.8-4.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.39,21.77c-.99-.69-2.21-1.09-3.51-1.09h-2.98v-2.98c0-.71-.12-1.39-.34-2.02-.51-1.46-1.54-2.67-2.87-3.41v8.41h-2.98c-1.65,0-2.98-1.33-2.98-2.98s1.33-2.98,2.98-2.98c.68,0,1.31.23,1.82.62v-3.56c-.57-.18-1.18-.27-1.82-.27-3.42,0-6.19,2.77-6.19,6.19,0,3.1,2.28,5.66,5.25,6.12.31.05.62.07.94.07h2.98v2.99c0,2.34,1.3,4.37,3.22,5.43.88.49,1.9.76,2.98.76,3.42,0,6.19-2.77,6.19-6.19,0-2.12-1.06-3.98-2.68-5.1ZM26.88,29.86c-1.65,0-2.98-1.33-2.98-2.98v-2.99h2.98c1.65,0,2.98,1.33,2.98,2.99s-1.33,2.98-2.98,2.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.64,
    y: 20.68,
    width: 4.04,
    height: 3.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 23.9,
    y: 20.68,
    width: 4.57,
    height: 3.21
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.bf0b29fb7a45e33339be512f50732700.svg";
export { ForwardRef as ReactComponent };